class CityController {
  constructor() {
    this.name = 'city';
  }
}

export default CityController;



// WEBPACK FOOTER //
// ./client/app/components/city/city.controller.js